import { useGetEntitlementOptions } from '@/services/club'
import { EntitlementOption, EntitlementType } from '@/types'

export type OperationEntitlements = Record<string, EntitlementType[]>

export const useClubEntitlementOptions = (clubId: number, enabled = true) => {
  const {
    data: optionsData,
    isLoading,
  } = useGetEntitlementOptions(clubId, enabled)

  const entitlementOptions: EntitlementOption[] = optionsData?.results?.[0]?.entitlements ?? []
  const operationOptions: string[] = optionsData?.results?.[0]?.operations ?? []

  return {
    entitlementOptions,
    operationOptions,
    isLoading,
  }
}
